import { render, staticRenderFns } from "./DepartmentDialog.vue?vue&type=template&id=735156d3"
import script from "./DepartmentDialog.vue?vue&type=script&lang=ts"
export * from "./DepartmentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports